export default __webpack_public_path__ + "static/tim-logo-zeichen-bunt-098ea7586094e483b3000a2591874eb2.svg";